import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            丰富视频分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            涵盖电影、电视剧、综艺、动漫等八大类别，满足您的多样化观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 flex flex-col items-center text-center transition-all duration-300 hover:scale-105 cursor-pointer border border-background-200/70 hover:border-primary-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.videoCount.toLocaleString()} 部资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}